import keys from 'mn-utils/keys';
import isFunction from "mn-utils/isFunction";
import * as links from '../../../constants/links';
import * as permissions from '../../../constants/permissions';
import {USER_TYPE_MERCHANT} from '../../../constants/userTypes';
import {replaceLocation} from "../../../router";
import {
  ACCOUNT_SETTINGS,
  LINK_MANAGEMENT,
  LINK_PBL, LINK_PBL_CREATE,
  LINK_PBL_DETAILS, LINK_PBL_REFUND,
  LINK_REFUND_DETAILS, LINK_SETTINGS, LINK_TERMINALS,
  LINK_TRANSACTION_REFUND_DETAILS
} from "../../../constants/links";

const userType = USER_TYPE_MERCHANT;

const PERMISSIONS_OF_ADMIN = keys(permissions.PERMISSIONS_MERCHANTS_ADMIN);

export default [
  [`^${links.LINK_DASHBOARD}?$`, {
    title: 'Dashboard',
    main: require('../../../components/pages/v2/Dashboard'),
    v2: 1,
    permissions: [
      permissions.PERMISSION_DASHBOARD,
    ],
  }],
  [`^${links.LINK_WITHDRAW}/([^/]+):type/([^/]+):assetCode$`, {
    title: 'Withdraw',
    main: require('../../../components/pages/v2/Withdraw'),
    v2: 1,
    permissions: [
      permissions.PERMISSION_WITHDRAW,
    ],
  }],


  [`^${links.LINK_TRANSACTIONS}/?$`, {
    title: 'Transactions',
    main: require('../../../components/pages/v2/Transactions'),
    v2: 1,
  }],
  [`^${links.LINK_TRANSACTION_DETAILS}/([^/]+):orderId(/([^/]*):paymentId(/([^/]*):auctionId)?(/([^/]*):refundId)?)?$`, {
    title: 'Transaction details',
    main: require('../../../components/pages/v2/Transactions/Details').default,
    v2: 1,
  }],
  [`^${links.LINK_TRANSACTION_REFUND}/([^/]+):orderId(/([^/]*):paymentId)?$`, {
    title: 'Refund',
    main: require('../../../components/pages/v2/Transactions/Refund'),
    v2: 1,
  }],
  [`^${links.LINK_REFUND_DETAILS}/([^/]+):id/?$`, {
    title: 'Refund details',
    main: require('../../../components/pages/v2/Refund/Details').default,
    v2: 1,
  }],


  [`^${links.LINK_PBL}/?$`, {
    title: 'Pay by Link',
    main: require('../../../components/pages/v2/PayByLink'),
    v2: 1,
  }],
  [`^${links.LINK_PBL}/([^/]+):id$`, {
    title: 'Payment link',
    main: require('../../../components/pages/v2/PayByLink/NewPaymentLink'),
    v2: 1,
  }],
  [`^${links.LINK_PBL_DETAILS}/([^/]+):id(/([^/]+):auction_id)?$`, {
    title: 'Pay by Link Details',
    main: require('../../../components/pages/v2/PayByLink/Details').default,
    v2: 1,
  }],
  [`^${links.LINK_PBL_REFUND}/([^/]+):orderId(/([^/]*):paymentId)?$`, {
    title: 'Refund',
    main: require('../../../components/pages/v2/Transactions/Refund'),
    v2: 1,
  }],

  // Terminals paths
  [`^${links.LINK_TERMINALS}?$`, () => {
    replaceLocation({
      path: links.LINK_TERMINALS_DASHBOARD,
    });
  }],
  [`^${links.LINK_TERMINALS}/([^/]+):pathId(/([^/]*):subPathId)?$`, {
    title: 'Terminals',
    main: require('../../../components/pages/v2/Terminals'),
    v2: 1,
    permissions: [
      permissions.PERMISSION_ORDER_TERMINAL_AND_TERMINAL_DETAILS,
    ],
  }],

  // Settings paths
  [`^${links.LINK_SETTINGS}?$`, () => {
    replaceLocation({
      path: links.LINK_MANAGEMENT,
    });
  }],
  [`^${links.LINK_SETTINGS}/([^/]+):pathId(/([^/]*):subPathId)?$`, {
    title: 'Management',
    main: require('../../../components/pages/v2/Settings'),
    v2: 1
  }],

  // Account Paths
  [`^${ACCOUNT_SETTINGS}?$`, () => {
    replaceLocation({
      path: '/account/settings/profile',
    });
  }],
  [`^${ACCOUNT_SETTINGS}/([^/]+):pathId?$`, {
    title: 'Account Settings',
    main: require('../../../components/pages/v2/AccountSettings'),
    v2: 1,
  }],




  [`^/?refer-and-earn/?$`, {
    title: 'Refer and earn',
    main: require('../../../components/pages/v2/ReferAndEarn'),
    v2: 1,
  }],
  [`^/?getting-started/?$`, {
    title: 'Getting started',
    main: require('../../../components/pages/v2/GettingStarted'),
    v2: 1,
  }],

  [`^${links.LINK_WITHDRAWAL}/([^/]+):type/([^/]+):id$`, {
    title: 'Withdrawal',
    main: require('../../../components/pages/v2/Withdrawal'),
    v2: 1,
  }],
].map(([url, data]) => [url, isFunction(data) ? data : {...data, userType}]);
